import { useAllocateSegment } from '../useAllocateSegment';
import { useArchiveSegment } from '../useArchiveSegment';
import { useCreateSegment } from '../useCreateSegment';
import { useUpdateSegment } from '../useUpdateSegment';

export const useSegmentMutations = () => {
  const { createSegment } = useCreateSegment();
  const { updateSegment } = useUpdateSegment();
  const { allocateSegment } = useAllocateSegment();
  const { archiveSegment } = useArchiveSegment();

  return {
    createSegment,
    updateSegment,
    allocateSegment,
    archiveSegment,
  };
};
